module.exports = __webpack_public_path__ + "static/media/signage-indoor-img69.65980df6.jpg";